import React, { useEffect, useState } from 'react';
import { Modal, Button } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
const OpcionesLlamadasModal = ({ open, onClose }) => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const { user, userTickets } = useUser();
  const { tienePermiso } = useAccesos();
  const idPersonal = userTickets?.idPersonal;
  const idSucursal = userTickets?.idSucursal;
  const idUbicacion = userTickets?.idUbicacionSeleccionada;

  const [enLinea, setEnLinea] = useState(null);

  // Estado para mostrar el ticket que estamos atendiendo
  const [ticketActual, setTicketActual] = useState(null);


  useEffect(() => {
    if (open) {
      // Al abrir el modal, obtener el valor de en_linea
      const fetchLoginData = async () => {
        try {
          const response = await fetch(`${server}/tickets/tbl_login/${userTickets.idPersonal}`);
          if (!response.ok) throw new Error('Error al obtener datos de login');
          const data = await response.json();
          // data debería tener el campo en_linea
          // Supongamos que "en_linea" es booleano o entero. Si es un booleano, data.en_linea debería ser true/false
          // Si es entero (0/1), lo convertimos a booleano: !!data.en_linea
          console.log('al abrir el modal ' + data.activo_login);
          console.log(data);
          setEnLinea(data.en_linea);

        } catch (error) {
          console.error(error);
        }
      };
      fetchLoginData();
    }
  }, [open]);

  const asignacionTicket = async () => {
    try {
      console.log('entro a asignacion ticket');
      // 1) Verificar si ya hay un ticket en atención
      cambiarEstadoTicket(0, 1);

      // 1) Obtener la respuesta principal de personal_ubicacion
      const personalUbicacionRes = await fetch(`${server}/tickets/tbl_personal_ubicacion/byPersonalbyUbicacion/${idPersonal}/${idUbicacion}`);
      if (!personalUbicacionRes.ok) {
        throw new Error(`Error al obtener personal_ubicacion: ${personalUbicacionRes.statusText}`);
      }
      const personalUbicacionData = await personalUbicacionRes.json();
      console.log('Datos personal_ubicacion:', personalUbicacionData);

      // 2) Iterar directamente sobre personalUbicacionData.$values
      const listaServicios = personalUbicacionData.$values || [];
      console.log('Lista de servicios:', listaServicios);

      // Estado para almacenar el ticket actual
      let ticketAsignado = null;

      // 3) Iterar sobre `listaServicios`
      for (const pu of listaServicios) {
        const idServicio = pu.id_servicios;
        const idSucursalServicio = pu.id_sucursal;

        // 4) Buscar pendientes por cada idServicio y idSucursal
        const pendientesRes = await fetch(`${server}/tickets/tbl_ticket/pendientesbySucursal/${idSucursalServicio}/${idServicio}`);
        if (!pendientesRes.ok) {
          console.error(`Error al obtener tickets pendientes para servicio ${idServicio}:`, pendientesRes.statusText);
          continue;
        }

        const pendientesData = await pendientesRes.json();
        console.log(`Tickets pendientes para servicio ${idServicio}:`, pendientesData);

        // 5) Si hay pendientes, tomar el primer ticket
        if (pendientesData.$values && pendientesData.$values.length > 0) {
          const ticket = pendientesData.$values[0];
          const idTicket = ticket.id_ticket; // Verificar que el campo es 'id_ticket'

          // 6) Obtener datos completos del ticket
          const datosTicketRes = await fetch(`${server}/tickets/tbl_ticket/${idTicket}`);
          if (!datosTicketRes.ok) {
            console.error(`Error al obtener datos del ticket ${idTicket}:`, datosTicketRes.statusText);
            continue;
          }
          const datoTicket = await datosTicketRes.json();
          console.log(`Datos del ticket ${idTicket}:`, datoTicket);

          // 7) Preparar el objeto para actualizar el ticket
          const putData = {
            id_ticket: datoTicket.id_ticket,
            id_sucursal: datoTicket.id_sucursal,
            id_ubicacion: idUbicacion,
            cod_ticket: datoTicket.cod_ticket,
            hora_atencion: datoTicket.hora_atencion,
            hora_salida: datoTicket.hora_salida,
            hora_inicio: datoTicket.hora_inicio,
            prioritario: datoTicket.prioritario,
            estado: 2, // Estado actualizado
            id_servicio: datoTicket.id_servicio,
            imprimir: 1,
            llamado: true,
            id_personal: userTickets.idPersonal,
          };
          console.log('Datos para actualizar el ticket:', putData);

          // 8) Realizar el PUT a tomarticket
          const putResponse = await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicket}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(putData)
          });

          if (putResponse.ok) {
            console.log(`Ticket ${idTicket} asignado exitosamente.`);
            ticketAsignado = datoTicket; // Guardar el ticket asignado
            break; // Salir del bucle una vez asignado un ticket
          } else {
            console.error(`Error al asignar el ticket ${idTicket}:`, putResponse.statusText);
          }
        }
      }
      // 9) Actualizar el estado local con el ticket asignado
      if (ticketAsignado) {
        setTicketActual(ticketAsignado);

        cambiarDisponible(true);


      } else {
        setTicketActual(null);
        cambiarDisponible(false);


        console.warn('No se asignó ningún ticket.');

      }

    } catch (error) {
      console.error('Error en asignacionTicket:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Ocurrió un error al asignar el ticket.',
      });
    }
  };

  const cambiarEstadoTicket = async (estado, boton) => {
    if (ticketActual) {
      // Finalizar el ticket actual
      const idTicketActual = ticketActual.id_ticket;
      const fechaSalida = new Date().toISOString(); // Formato ISO para la fecha y hora actual
      const putDataUpdate = {
        id_ticket: ticketActual.id_ticket,
        id_sucursal: ticketActual.id_sucursal,
        id_ubicacion: ticketActual.id_ubicacion,
        cod_ticket: ticketActual.cod_ticket,
        hora_atencion: ticketActual.hora_atencion,
        hora_salida: fechaSalida,
        hora_inicio: ticketActual.hora_inicio,
        prioritario: ticketActual.prioritario,
        estado: estado, // Estado actualizado
        id_servicio: ticketActual.id_servicio,
        imprimir: ticketActual.imprimir,
        llamado: false,
        id_personal: idPersonal,
      };

      const putResponse = await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicketActual}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putDataUpdate),
      });

      if (putResponse.ok) {
        console.log(`Ticket ${idTicketActual} actualizado exitosamente.`);
        if (boton === 3 || boton === 4 || boton === 5) {
          setTicketActual(null); // Limpiar el ticket actual
        }

      } else {
        const errorData = await putResponse.json();
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: errorData.message || 'No se pudo finalizar el ticket actual.',
        // });
        console.error('Error al finalizar el ticket actual:', errorData);
        return; // No continuar con la asignación si falla
      }
    }
  }

  const handleDejarDeAtender = async () => {

    try {
      // Finalizar el ticket actual si existe
      cambiarEstadoTicket(0, 5);

      const loginResponseUbicacion = await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacion}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!loginResponseUbicacion.ok) {
        throw new Error('Error al obtener datos de login');
      }
      const loginDataUbicacion = await loginResponseUbicacion.json();

      const putDataUbicacion = {
        id_ubicacion: loginDataUbicacion.id_ubicacion,
        id_sucursal: loginDataUbicacion.id_sucursal,
        nombre_ubicacion: loginDataUbicacion.nombre_ubicacion,
        estado_ubicacion: true,
        activo_ubicacion: true,
      };
      console.log('paso aqui');
      await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacion}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putDataUbicacion)
      });



      const loginResponse = await fetch(`${server}/tickets/tbl_login/${userTickets.idPersonal}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!loginResponse.ok) {
        throw new Error('Error al obtener datos de login');
      }
      console.log(loginResponse);
      const loginData = await loginResponse.json();
      console.log(loginData);
      // Crear un nuevo objeto con solo los campos necesarios
      const putData = {
        id_login: loginData.id_login,
        tipo: loginData.tipo,
        id_personal: loginData.id_personal,
        login: loginData.login,
        pass: loginData.pass,
        activo_login: loginData.activo_login,
        en_linea: false// Agregar el campo en_linea
      };
      const idLogin = loginData.id_login;
      console.log(putData);
      // PUT /api/tickets/tbl_login/{id} en_linea=1
      await fetch(`${server}/tickets/tbl_login/${idLogin}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putData)
      });

      setEnLinea(false);
      onClose();
    } catch (error) {
      console.error('Error en handleDejarDeAtender:', error);

    }
  };

  const cambiarDisponible = async (disponible) => {

    const loginResponseUbicacion = await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacion}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!loginResponseUbicacion.ok) {
      throw new Error('Error al obtener datos de login');
    }
    const loginDataUbicacion = await loginResponseUbicacion.json();

    const putDataUbicacion = {
      id_ubicacion: loginDataUbicacion.id_ubicacion,
      id_sucursal: loginDataUbicacion.id_sucursal,
      nombre_ubicacion: loginDataUbicacion.nombre_ubicacion,
      estado_ubicacion: true,
      activo_ubicacion: disponible,
    };

    await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacion}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(putDataUbicacion)
    });
  };

  const handleLlamar = async () => {
    await asignacionTicket();
  };

  const handlePausa = async () => {


    cambiarEstadoTicket(0, 4);


    cambiarDisponible(false);
  };

  const handlePerdido = async () => {
    cambiarEstadoTicket(3, 3);

    // const res = await fetch(`${server}/tickets/tbl_ticket/bypersonal/${idPersonal}`);
    // const data = await res.json();
    // if (data.$values && data.$values.length > 0) {
    //   const ticketActual = data.$values[0];
    //   const idTicket = ticketActual.id;

    //   await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicket}`, {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ estado: 3 })
    //   });

    //   await asignacionTicket();
    // }
  };



  const handleVolverALlamar = async () => {
    if (ticketActual) {
      // Finalizar el ticket actual
      const idTicketActual = ticketActual.id_ticket;

      const fechaActual = new Date().toISOString(); // Formato ISO para la fecha y hora actual
      const putDataUpdate = {
        id_ticket: ticketActual.id_ticket,
        id_sucursal: ticketActual.id_sucursal,
        id_ubicacion: ticketActual.id_ubicacion,
        cod_ticket: ticketActual.cod_ticket,
        hora_atencion: fechaActual,
        hora_salida: ticketActual.hora_salida,
        hora_inicio: ticketActual.hora_inicio,
        prioritario: ticketActual.prioritario,
        estado: 2, // Estado actualizado
        id_servicio: ticketActual.id_servicio,
        imprimir: 1,
        llamado: true,
       // id_personal: idPersonal,
      };

      const putResponse = await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicketActual}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putDataUpdate),
      });

      if (putResponse.ok) {
        console.log(`Ticket ${idTicketActual} actualizado exitosamente.`);
      } else {
        console.error(`Error al actualizar el ticket ${idTicketActual}:`, putResponse.statusText);
      }
    }
    // const res = await fetch(`${server}/tickets/tbl_ticket/bypersonal/${idPersonal}`);
    // const data = await res.json();
    // if (data.$values && data.$values.length > 0) {
    //   const ticketActual = data.$values[0];
    //   const idTicket = ticketActual.id;

    //   await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicket}`, {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ estado: 3 })
    //   });

    //   await asignacionTicket();
    // }
  };



  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: 24,
    outline: 'none',
  };

  // Si enLinea no se ha obtenido aún, mostramos algo o deshabilitamos todos los botones
  const botonesHabilitados = enLinea; // Asumiendo que en_linea viene como 0/1

  return (
    <Modal open={open} onClose={onClose}>
      <div style={modalStyle}>
        <h2>Opciones de Atención</h2>

        {/* Sección donde mostramos el ticket en atención */}
        <div style={{ marginBottom: '10px', border: '1px solid #ccc', padding: '10px' }}>
          {ticketActual ? (
            <div>
              <h4>Ticket en atención</h4>
              <p>Codigo Ticket: {ticketActual.cod_ticket}</p>
              {/* Muestra otros campos que consideres necesarios */}
            </div>
          ) : (
            <p>No hay ticket en atención actualmente</p>
          )}
        </div>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLlamar}
            disabled={!botonesHabilitados || !tienePermiso('Crear Atención Ticket')}
          >
            Llamar
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: '', color: '#fff' }}
            onClick={handleVolverALlamar}
            disabled={!botonesHabilitados || !tienePermiso('Editar Atención Ticket')}
          >
            Volver a llamar
          </Button>

          <Button
            variant="contained"
            style={{ backgroundColor: '#00acc1', color: '#fff' }}
            onClick={handlePerdido}
            disabled={!botonesHabilitados || !tienePermiso('Editar Atención Ticket')}
          >
            Perdido
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: '#ff9800', color: '#fff' }}
            onClick={handlePausa}
            disabled={!botonesHabilitados || !tienePermiso('Editar Atención Ticket')}
          >
            Pausa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDejarDeAtender}
            disabled={!botonesHabilitados || !tienePermiso('Eliminar Atención Ticket')}
          >
            Dejar de Atender
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default OpcionesLlamadasModal;
